module.exports = __webpack_public_path__ + "assets/img/4.01c9ce14.png";